import { render } from "./ConservatoryTests.vue?vue&type=template&id=4ee470dc"
import script from "./ConservatoryTests.vue?vue&type=script&lang=js"
export * from "./ConservatoryTests.vue?vue&type=script&lang=js"

import "./ConservatoryTests.vue?vue&type=style&index=0&id=4ee470dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__